import script from "./CheckboxgroupElement.vue?vue&type=script&lang=js"
export * from "./CheckboxgroupElement.vue?vue&type=script&lang=js"

import "./CheckboxgroupElement.vue?vue&type=style&index=0&id=5f844b74&lang=scss"

const __exports__ = script;

export default __exports__